import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';
import { loopScrollTarget } from '@theme/eme-grid-core';

class EmeReviews extends Component {
  requiredRefs = ['track'];
  #resizeObserver = null;

  connectedCallback() {
    super.connectedCallback();
    this.#resizeObserver = new ResizeObserver(this.#syncOverflow);
    this.#resizeObserver.observe(this.refs.track);
    this.#syncOverflow();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#resizeObserver?.disconnect();
    this.#resizeObserver = null;
  }

  previous() {
    this.#slide(-1);
  }

  next() {
    this.#slide(1);
  }

  #syncOverflow = () => {
    const { track } = this.refs;
    this.toggleAttribute('data-static', track.scrollWidth - track.clientWidth <= 1);
  };

  #slide(direction) {
    const { track } = this.refs;
    const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
    const left = loopScrollTarget({
      position: track.scrollLeft,
      maxScroll: track.scrollWidth - track.clientWidth,
      step: track.clientWidth + gap,
      direction,
    });
    track.scrollTo({ left, behavior: prefersReducedMotion() ? 'instant' : 'smooth' });
  }
}

if (!customElements.get('eme-reviews')) customElements.define('eme-reviews', EmeReviews);
